import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import aboutImage from '../assets/about.jpg';
import { useEffect } from 'react';
function About() {
   useEffect(() => {
    window.scrollTo(0, 10);
  }, []);

  return (
    <div className="bg-gradient-custom min-vh-100">
      <Navbar />
      <div className="container py-5">
        <h2 className="font-josefin font-light text-4xl text-uppercase text-center mb-5">
          ABOUT LOOPSTUDIOS
        </h2>
        <div className="row align-items-center g-4">
          <div className="col-12 col-md-7 mb-4 mb-md-0">
            <img src={aboutImage} alt="About Loopstudios" className="img-fluid w-100 rounded" />
          </div>
          <div className="col-12 col-md-5 bg-white p-5 shadow-sm">
            <h3 className="font-josefin font-light text-3xl text-uppercase mb-3">
              OUR STORY
            </h3>
            <p className="text-secondary line-height-relaxed">
              Founded in 2011, Loopstudios has been at the forefront of virtual reality innovation. 
              We specialize in creating immersive experiences that push the boundaries of technology, 
              working with top-tier companies to bring their visions to life.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default About;